import { createAsyncThunk } from "@reduxjs/toolkit"
import { fetchMovieDetails } from "../../services/moviesAPI"

export const movieDetailsThunk = createAsyncThunk(
  "movie",
  async (id: string) => {
    const results = (await fetchMovieDetails(id)).data
    return results
  }
)
